import { Route, Routes } from 'react-router-dom';
import  BalloonGameDemo  from './components/BalloonGame';
import Feedback from './components/Feedback';
import NotFound from './components/NotFound';
import Landing from './components/LandingPage';
import TowersGameDemo from './components/TowersGame';
import axios from 'axios';

axios.defaults.withCredentials = true;
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;

const AppRouter = () => {
  
    return (
      <Routes>
        <Route path ="/demo" element={<BalloonGameDemo />} />
        <Route path="/feedback" element={<Feedback gameCode="BAR2" />} />
        <Route path="/towers/feedback" element={<Feedback gameCode="TOW2" />} />
        <Route path ="/notFound" element={<NotFound />} />
        <Route path ="/" element={<Landing/>} />
        <Route path="/towers/demo" element={<TowersGameDemo />} />
      </Routes> 
    )
};

export default AppRouter;